module.exports = __webpack_public_path__ + "img/icon_qingpai_des_4.0b5ebd1e.jpg";